/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-12-02 08:50:50
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import Modal from 'src/types/iview/Modal';
import Button from 'src/types/iview/Button';
import { modalFactory } from 'src/util/vueExtend';
import { createNamespace, createBEM } from 'src/util/bem';
import './selectLocationModal.less'
import Input from 'src/types/iview/Input';
let bem = createBEM('select-location')

export namespace SelectLocationVOI {
    export interface PropsI {
        data: {location_point: string,areaNames: string[], address: string}
        saveSuccess?(str: string, areaNames: string[], address: string): void;

        cancel?(): void;
    }
}

@Component
class SelectLocationModal extends Vue.Component<SelectLocationVOI.PropsI> {
    @Prop({
        type: Function,
    })
    cancel!: () => void;

    @Prop({
        type: Object,
    })
    data!: {location_point: string,areaNames: string[], address: string};

    @Prop({
        type: Function,
    })
    saveSuccess!: (str: string, areaNames: string[], address: string) => void;

    visible: boolean = false;

    loading: boolean = false;

    map: any;

    location: string = ''
    areaNames: string[] = []
    address: string = ''
    inputAddress: string = ''

    close() {
        this.cancel && this.cancel();
        this.closeModal();
    }

    closeModal() {
        this.visible = false;
        this.$emit('close', false);
    }

    initMap() {
        var map = new BMapGL.Map('map');
        this.map = map;
        let t = this
        map.enableScrollWheelZoom(true);
        // map.setMapStyleV2({style:'dark'})
        map.setMapStyleV2({
            styleId: '9bb94d6e012814f7781cca9a8e69b853',
        });
        var geoc = new BMapGL.Geocoder();
        map.addEventListener('click', function(e) {
            console.log('e', e)
            let lng = e.latlng.lng.toFixed(6)
            let lat = e.latlng.lat.toFixed(6)
            t.location = lng + ',' + lat
            map.clearOverlays()
            let point = new BMapGL.Point(lng, lat)
            var marker = new BMapGL.Marker(point);
            map.addOverlay(marker);
            geoc.getLocation(point, function(rs){
                let {province, city, district} = rs.addressComponents
                t.address = rs.address.replace(province, '').replace(city, '').replace(district, '')
                t.areaNames = [province,city,district]
            })
        });
        if (this.data.location_point) {
            let location_point = this.data.location_point.split(',')
            let point = new BMapGL.Point(location_point[0], location_point[1])
            // 创建点标记
            var marker = new BMapGL.Marker(point);
            map.addOverlay(marker);
            map.centerAndZoom(point,12);

        } else {
            map.centerAndZoom(new BMapGL.Point(116.404, 39.915), 12);
        }
    }
    mounted() {
        this.location = this.data.location_point
        this.areaNames = this.data.areaNames
        this.address = this.data.address
        setTimeout(i=> {
            this.initMap();
        },500)
    }

    async save() {
        this.saveSuccess(this.location, this.areaNames, this.address)
		this.closeModal()
    }

    refreshAddress(){
        var local = new BMapGL.LocalSearch(this.map, {
            renderOptions:{map: this.map}
        });
        local.search(this.inputAddress);
    }

    render(h) {
        return (
            <Modal class={createNamespace('modal-fix-height')} title="获取经纬度" width="1000" v-model={this.visible} mask-closable={false} on-on-cancel={this.close}>
                <div class={bem('wrapper')}>
                    <div class={bem('top-bar')}>
                        <div class={bem('address')}>
                            <span class={createNamespace('mr10')}>经纬度：{this.location}</span>
                            <span>地址: {this.areaNames.join('')+this.address}</span>
                        </div>
                        <div class={bem('title')}>当前位置</div>
                        <Input style="width:20%;right:10px;" v-model={this.inputAddress} placeholder="请输入地址"/>
                        <Button type="primary" on-click={this.refreshAddress} style="margin-right: 5px;">
                           搜索
                        </Button>
                    </div>
                    <div id="map" style="height:calc(100% + 25px);" />
                </div>
                <div slot="footer">
                    <Button type="primary" ghost on-click={this.close}>
                        取消
                    </Button>
                    <Button type="primary" on-click={this.save} loading={this.loading}>
                        保存
                    </Button>
                </div>
            </Modal>
        );
    }
}

export default function alertSelectLocationModal(data: {location_point: string,areaNames: string[], address: string}): Promise<{areaNames: string[], address: string, location: string }|null> {
    return new Promise((resolve, reject) => {
        modalFactory<SelectLocationVOI.PropsI>(SelectLocationModal)({
            data,
            saveSuccess(location: string, areaNames: string[], address: string) {
                resolve({areaNames, address, location });
            },
            cancel() {
                resolve(null);
            },
        });
    });
}
